export const GAME_INFO_CARD_TYPES = {
  HOW_TO_PLAY: 'how_to_play',
  PAYTABLE: 'paytable',
} as const;

export type GameInfoCardType =
  (typeof GAME_INFO_CARD_TYPES)[keyof typeof GAME_INFO_CARD_TYPES];
